import { IUnmanagedBusiness } from '@/coreDomainsModule/entities/unmanagedBusiness';
import { INetworkResult } from '@/coreDomainsModule/networkResult';
import { IUnmanagedBusinessRepository } from '@/coreInfrastructureModule/interfaces/IUnmanagedBusinessRepository';

/**
 * 未管理を削除するユースケース
 */
export class DeleteUnmanagedBusinessUseCase {
  private repository: IUnmanagedBusinessRepository;

  /**
   * コンストラクタ
   * @param repository - 未管理の取引の永続化の責務を負うクラス
   */
  constructor(repository: IUnmanagedBusinessRepository) {
    this.repository = repository;
  }

  /**
   * 未管理の取引を削除する
   * @param businessId - 未管理の取引ID
   */
  public execute(businessId: IUnmanagedBusiness['businessId']): INetworkResult<IUnmanagedBusiness | void, Error> {
    try {
      return this.repository.delete(businessId);
    } catch (error) {
      console.error(error);
      return {
        status: {
          type: 'error',
          error: Error('想定外のエラーが発生しました'),
        },
      }; // 基本的にはここには到達しないはず
    }
  }
}
